var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLostfound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 449.67 442.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0e0e0;}.cls-2{fill:#ebebeb;}.cls-3{fill:#fafafa;}.cls-4{fill:#f5f5f5;}.cls-5{fill:#263238;}.cls-6{fill:#455a64;}.cls-7{fill:#ffbe9d;}.cls-8{fill:#eb996e;}.cls-9{fill:#ff725e;}.cls-10{fill:#fff;}.cls-11{opacity:0.3;}.cls-12{opacity:0.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.23,
    y: 10.58,
    width: 88.51,
    height: 146.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.28,
    y: 10.58,
    width: 88.51,
    height: 146.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.05,
    y: 13.55,
    width: 80.98,
    height: 140.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.47,
    y: 31.81,
    width: 49.79,
    height: 104.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.21,128.05c-.12-9.72,8.62-19.21,18.24-20.56,4.59-.65,9.47.26,13.76-1.5,7.65-3.14,10.09-13.31,17.79-16.32l.35,75.2H74.21Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.78,
    y: 16.07,
    width: 84.89,
    height: 88.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 359.03,
    y: 16.07,
    width: 84.89,
    height: 88.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.68,133.59H381.74V45.05h84.94Zm-84.89-.05h84.84V45.1H381.79Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 370.44,
    y: 27.96,
    width: 62.07,
    height: 64.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.18,122.1a9.77,9.77,0,0,1-1.53,1.78c-1,1.05-2.39,2.46-3.95,4s-3,2.91-4.05,3.88a9.63,9.63,0,0,1-1.8,1.5,10.18,10.18,0,0,1,1.53-1.78c1-1,2.38-2.46,3.95-4s3-2.92,4.06-3.89A9.82,9.82,0,0,1,393.18,122.1Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.25,121.94a10.63,10.63,0,0,1,1.78,1.53c1,1,2.46,2.39,4,4s2.9,3,3.88,4.06a9.43,9.43,0,0,1,1.49,1.79,10,10,0,0,1-1.77-1.52c-1.05-1-2.47-2.39-4-4s-2.92-3-3.89-4.06A9.44,9.44,0,0,1,455.25,121.94Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.08,57.15a9.77,9.77,0,0,1,1.53-1.78c1-1,2.38-2.47,3.94-4s3-2.91,4.06-3.89A10.38,10.38,0,0,1,466.4,46a10,10,0,0,1-1.52,1.77c-1,1.05-2.39,2.47-4,4s-3,2.92-4.06,3.89A11.09,11.09,0,0,1,455.08,57.15Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393,57.3a9.77,9.77,0,0,1-1.78-1.53c-1.05-1-2.46-2.38-4-3.94s-2.91-3-3.88-4.06a10.21,10.21,0,0,1-1.5-1.79,9.8,9.8,0,0,1,1.78,1.52c1,1,2.46,2.39,4,4s2.92,3,3.89,4.06A9.86,9.86,0,0,1,393,57.3Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.08,121.67a1.92,1.92,0,0,1,0-.31c0-.22,0-.52,0-.91,0-.81,0-2,0-3.49,0-3.06,0-7.52-.06-13.18,0-11.34-.07-27.48-.12-46.81l.24.24-61.89,0h0l.27-.28c0,23.75,0,46,0,64.7l-.24-.23,44.82.12,12.58.06,3.34,0h1.16a1.45,1.45,0,0,1-.28,0H454l-3.29,0-12.53.06-45,.12h-.24v-.24c0-18.73,0-40.95,0-64.7V56.7h.29l61.89,0h.24V57c-.06,19.4-.1,35.59-.13,47,0,5.64,0,10.08-.06,13.13q0,2.25,0,3.45c0,.37,0,.66,0,.87S455.08,121.68,455.08,121.67Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 391.12,
    y: 49.95,
    width: 20.71,
    height: 20.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M344.2,459.75c-1.76-1.51-5.7-6.3-2.66-11.88,1.11-2,3.48-3.06,5.61-4s4.39-1.68,6.16-3.19c3.34-2.84,4.26-7.55,6.48-11.34,2.54-4.35,7.29-7.61,12.31-7.38,5.74.26,10.53,4.95,12.7,10.3s2.25,11.29,2.3,17.07c0,3.19-.12,6.79-2.47,8.95-2.16,2-5.41,2-8.35,1.92l-31.39-1",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.25,373.43H321.69l14.87,88.67a9.9,9.9,0,0,0,7.05,7.9l.29.08c.24.06.48.14.73.19a10.41,10.41,0,0,0,1.68.19l0,.09.4-.07h36.8a10.4,10.4,0,0,0,2-.2,9.94,9.94,0,0,0,8.35-8.67l7.17-61.1.32-2.43h0l2.83-24.19ZM388.67,430H380.2l.86-25.73h9.81Zm3-25.73h8.12l-3,25.73H389.5Zm-24.2,54.26L367,436.16h12.21l-.75,22.36ZM354.3,436.16h11.85l.52,22.36H356Zm.92,22.36h-9.94c-.95-6-2.18-13.88-3.51-22.36h11.71ZM353.82,430l-2-25.73h13.6L366,430Zm13,0-.59-25.73h14L379.38,430Zm-.73-31.91-.55-23.83h15.68l-.79,23.83Zm-.82,0H351.34l-1.85-23.83h15.24Zm-14.76,0H335.77c-.52-3.29-1-6.4-1.46-9.21-1.54-9.63-2.12-13.26-2.44-14.62h16.8Zm.48,6.18L353,430H340.8c-.41-2.61-.82-5.25-1.24-7.89-.95-6.08-1.91-12.15-2.81-17.84ZM340,430h-8l-4.32-25.73h8.23C337.18,412.21,338.57,421.06,340,430Zm1,6.17c1.22,7.74,2.41,15.37,3.51,22.36h-7.66L333,436.16Zm38.31,22.36.75-22.36h8.15l-1.91,22.36Zm2-60.44.79-23.83h11.39l-2,23.83Zm-50.17-23.83c.33,1.72,1.83,11.1,3.85,23.83h-8.29l-4-23.83Zm62.35,84.27h-6.38L389,436.16h7.09Zm7.09-60.44h-8.31l2-23.83h9.07Z",
    transform: "translate(-22.74 -29.01)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M451.24,471.41c0,.15-95.93.26-214.24.26s-214.26-.11-214.26-.26,95.91-.26,214.26-.26S451.24,471.27,451.24,471.41Z",
    transform: "translate(-22.74 -29.01)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.51,363.08,223,363a24.73,24.73,0,0,1-24.71-24.73l0-284.56A24.73,24.73,0,0,1,223.09,29l113.51.07a24.73,24.73,0,0,1,24.71,24.73l-.06,284.55A24.72,24.72,0,0,1,336.51,363.08Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.48,39.14h-22a5.46,5.46,0,0,0-5.34,5.58v4a5.46,5.46,0,0,1-5.34,5.58l-42.9,0a5.47,5.47,0,0,1-5.34-5.59v-4a5.47,5.47,0,0,0-5.34-5.59h-27a17.31,17.31,0,0,0-17.33,17.31l-.05,277.75a17.32,17.32,0,0,0,17.3,17.32l113.28.06a17.31,17.31,0,0,0,17.33-17.31l0-277.75A17.32,17.32,0,0,0,336.48,39.14Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 292.8,
    y: 19.14,
    width: 1.26,
    height: 1.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 294.85,
    y: 18.35,
    width: 1.26,
    height: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 296.9,
    y: 17.76,
    width: 1.26,
    height: 3.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.94,
    y: 16.63,
    width: 1.26,
    height: 4.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.51,50H335.2a.46.46,0,0,1-.46-.45V46.41a.45.45,0,0,1,.45-.45h6.32a.11.11,0,0,1,.08,0,.16.16,0,0,1,0,.09v1h.68a.12.12,0,0,1,.12.12v1.51a.12.12,0,0,1-.12.11h-.68v1A.11.11,0,0,1,341.51,50Zm-.12-3.81h-6.2a.22.22,0,0,0-.22.22v3.14a.22.22,0,0,0,.23.22h6.19v-1a.12.12,0,0,1,.12-.12h.67V47.34h-.67a.11.11,0,0,1-.12-.11Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "312.75 20.25 312.75 17.7 318.14 17.7 318.14 18.84 318.14 19.09 318.14 20.25 312.75 20.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329,49.76a.47.47,0,0,0-.46-.46.46.46,0,0,0-.46.46.45.45,0,0,0,.46.46A.46.46,0,0,0,329,49.76Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.92,48.65l.59.59a1.39,1.39,0,0,1,2,0l.59-.59A2.22,2.22,0,0,0,328.5,48,2.25,2.25,0,0,0,326.92,48.65Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M328.5,46.68a3.52,3.52,0,0,0-2.5,1l.58.59a2.72,2.72,0,0,1,3.83,0l.59-.59A3.54,3.54,0,0,0,328.5,46.68Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M325,46.76l.59.59a4.06,4.06,0,0,1,5.74,0l.59-.59a4.9,4.9,0,0,0-6.92,0Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.07,
    y: 44.68,
    width: 9.52,
    height: 7.07,
    rx: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.91,74.16h-1V73a3.66,3.66,0,1,1,7.31,0v.76h-1V73a2.66,2.66,0,1,0-5.31,0Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207,248.89a51,51,0,0,1,26.18-44c11-6,23.82-7.56,36.05-10.37s24.91-7.45,32.47-17.46c10.22-13.53,8.27-32.76,15.65-48A43.19,43.19,0,0,1,354,105.19V337.7a14.13,14.13,0,0,1-14.13,14.13H221.15A14.14,14.14,0,0,1,207,337.7Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232,127.79c0-8.62,4.52-13.76,10.79-13.76s10.82,5.14,10.82,13.76-4.56,13.77-10.82,13.77S232,136.41,232,127.79Zm18.75,0c0-7.23-3.25-11.21-8-11.21s-8,4-8,11.21,3.25,11.22,8,11.22S250.77,135,250.77,127.79Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M277.14,127.56c0,9.2-5,14-12.37,14a12.45,12.45,0,0,1-6.42-1.47l1.12-2.24a9.56,9.56,0,0,0,5.26,1.27c5.84,0,9.59-3.75,9.59-11.1,0-.61,0-1.39-.12-2.2-1.35,3-4.52,4.64-8.27,4.64-5.38,0-9.13-3.17-9.13-8.12s4-8.31,9.24-8.31C273.23,114,277.14,119,277.14,127.56Zm-3.83-5.37c0-3-2.47-5.8-7.15-5.8-3.91,0-6.61,2.28-6.61,5.87s2.63,5.84,6.8,5.84S273.31,125.55,273.31,122.19Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M281.2,122.92a2,2,0,0,1,2.05-2.09,2.07,2.07,0,0,1,2.08,2.09,2.11,2.11,0,0,1-2.08,2.13A2.08,2.08,0,0,1,281.2,122.92Zm0,16.47a2,2,0,0,1,2.05-2.09,2.07,2.07,0,0,1,2.08,2.09,2.11,2.11,0,0,1-2.08,2.13A2.08,2.08,0,0,1,281.2,139.39Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M307.84,138.85v2.48h-19v-2l11.25-11c3.06-3,3.64-4.83,3.64-6.69,0-3.13-2.21-5.06-6.34-5.06a9.2,9.2,0,0,0-7.39,3l-2-1.71c2.09-2.47,5.45-3.86,9.59-3.86,5.49,0,9,2.78,9,7.3,0,2.6-.81,4.92-4.45,8.47l-9.2,9Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M311.16,127.79c0-8.62,4.52-13.76,10.79-13.76s10.82,5.14,10.82,13.76-4.56,13.77-10.82,13.77S311.16,136.41,311.16,127.79Zm18.75,0c0-7.23-3.25-11.21-8-11.21s-8,4-8,11.21S317.23,139,322,139,329.91,135,329.91,127.79Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 233.63,
    cy: 89.32,
    r: 19.54,
    transform: "translate(74.45 269.94) rotate(-77.87)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.65,244.76c-1.41-1-3.15-1.42-4.72-2.16s-3.09-2-3.24-3.76c-.21-2.56,2.61-4.49,2.78-7,.23-3.61-4.65-5.58-5.36-9.12-.59-2.94,1.9-5.71,1.8-8.71s-2.7-5.23-3.88-8c-2.76-6.38,2.32-14.61-1.53-20.4a28.87,28.87,0,0,0-3.9-4c-1.32-1.32-2.47-3-2.31-4.91l-7.22-3.28c-2.42-3.7-7.91-3.84-12-2.26s-7.75,4.41-12,5.47c-2.08.51-1.78-2.57-3.88-2.14-2.77.56-6.16,3.79-7,6.47-.84,2.87-1.43,6.05-2.45,8.87-1.13,3.11-4.46,5.28-4.78,8.58-.36,3.84,3.61,7,3.62,10.84,0,4.15-4.58,7.87-3.12,11.76.84,2.22,3.4,3.41,4.3,5.61,1.23,3-1.22,6.38-1,9.65s2.94,5.67,5.51,7.63A115.91,115.91,0,0,0,99.7,261.72c5.07,1.74,10.41,3.07,15.75,2.59s10.71-3,13.51-7.62C131.25,252.94,131.23,247.33,127.65,244.76Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107,174.89a15.24,15.24,0,0,0-25.64-7c-1.54,1.56-2.76,3.47-4.58,4.69-2.06,1.39-2.36,1-4.66,1.89s-6.53,7.32-6.46,9.8l-1.15,10.86c.09,2.54,3.36,4,5.76,3.14s4-3.08,5.28-5.28S78,188.41,80.1,187c3.45-2.43,8.13-1.59,12.26-.75s8.92,1.45,12.15-1.27C107.29,182.59,107.89,178.42,107,174.89Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M109.28,190.39c-.47-7.07-5.17-15.73-12.21-15l-22,5.61a4.14,4.14,0,0,0-3.69,4.21l2.47,53-.16,0s9,18.95,23.48,14.38c2.88-.91.26-8.06.84-11.3l.14,0c0-.38,0-.74,0-1.11a34.78,34.78,0,0,0,.09-7.28h0c0-4.28,0-6,0-6s9-1.52,10.87-13.3C110.1,207.85,109.79,198.24,109.28,190.39Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.46,199.47A1.51,1.51,0,0,1,106,201a1.45,1.45,0,0,1-1.56-1.36,1.52,1.52,0,0,1,1.46-1.53A1.44,1.44,0,0,1,107.46,199.47Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.2,195.39c-.18.2-1.33-.64-3-.64s-2.81.83-3,.63.1-.45.62-.82a4.17,4.17,0,0,1,2.4-.75,4,4,0,0,1,2.35.76C107.12,195,107.3,195.3,107.2,195.39Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.09,200a1.5,1.5,0,0,1-1.45,1.52,1.44,1.44,0,0,1-1.56-1.36,1.5,1.5,0,0,1,1.45-1.52A1.44,1.44,0,0,1,92.09,200Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.22,195.73c-.18.2-1.33-.65-3-.64s-2.81.83-3,.63.1-.45.62-.83a4.22,4.22,0,0,1,2.4-.74,4,4,0,0,1,2.35.75C91.14,195.29,91.31,195.64,91.22,195.73Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.15,207.78a10.41,10.41,0,0,1,2.64-.49c.41,0,.81-.12.88-.41a2.2,2.2,0,0,0-.28-1.23c-.4-1-.81-2.05-1.24-3.16-1.71-4.49-3-8.19-2.77-8.26s1.72,3.52,3.43,8c.41,1.11.81,2.17,1.18,3.18a2.4,2.4,0,0,1,.22,1.63,1.05,1.05,0,0,1-.68.61,3.35,3.35,0,0,1-.7.1A10.92,10.92,0,0,1,97.15,207.78Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.32,227a30,30,0,0,1-15.79-4.17s3.84,8.08,15.63,7Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.47,211.7a2.92,2.92,0,0,0-2.63-1.09,2.66,2.66,0,0,0-1.84,1,1.69,1.69,0,0,0-.13,1.94,2,2,0,0,0,2.14.53,6.11,6.11,0,0,0,2.07-1.24,1.78,1.78,0,0,0,.46-.49.53.53,0,0,0,0-.6",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.37,208.91c.26,0,.27,1.75,1.78,3s3.39,1.05,3.41,1.3-.42.34-1.21.36a4.43,4.43,0,0,1-2.85-1,3.84,3.84,0,0,1-1.38-2.51C92.05,209.34,92.25,208.9,92.37,208.91Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92,192.88c-.16.45-1.79.24-3.69.47s-3.45.76-3.71.37c-.11-.19.16-.61.78-1a6.15,6.15,0,0,1,2.74-1,6.27,6.27,0,0,1,2.89.34C91.66,192.33,92,192.67,92,192.88Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.59,190.69c-.28.37-1.4,0-2.75,0s-2.48.26-2.75-.13c-.11-.19.07-.56.56-.91a4,4,0,0,1,4.44.13C106.56,190.13,106.72,190.51,106.59,190.69Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.68,172.41l-1-1.28a75.72,75.72,0,0,0-19.82,5.06c-2.54,1-5.1,2.26-6.84,4.38-2.38,2.91-2.76,6.93-3,10.68-1,14.3-1.89,29,2.61,42.63,1.08-1.74,3.2-2.52,5.21-2.91s4.12-.52,6-1.45a8.11,8.11,0,0,0,4-5.16,9.67,9.67,0,0,0-.73-6.56c-1.09-2.27-3-4.46-2.56-6.93s3.46-4.06,4.16-6.6c1.21-4.39-5-8.33-3.71-12.71A6.15,6.15,0,0,1,84.33,188c1.5-.75,3.15-1.17,4.67-1.88A13.78,13.78,0,0,0,96.68,172.41Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M156.16,262.23l-13.78,21.44a5.51,5.51,0,0,0,4.84,2.4c3.32-.14,7.88-8.42,8.42-10.09s-.19-3.29.3-4.41.3-4.18.3-4.18C156.17,267.57,159.22,263.49,156.16,262.23Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.57,283.66l7.18-28.39a3.26,3.26,0,0,1,1.53-2l10.43-5.95a1.44,1.44,0,0,1,1.87.41h0a1.44,1.44,0,0,1,.23,1.19l-7.6,29.88Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "112.21 276.65 128.88 245.86 122.61 237.73 99.15 255.53 105.29 272.45 112.21 276.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M151.82,281.55a7.19,7.19,0,0,0,.32-1.27,9.47,9.47,0,0,0-.35-3.56l0-.07,0-.07A1.92,1.92,0,0,0,152,275a3.06,3.06,0,0,0-1.17-1.45l-.18-.12.12-.19,1.89-2.82a3.63,3.63,0,0,0,.44-.73,1,1,0,0,0-.06-.74,3.54,3.54,0,0,0-1.16-1.32l-.24-.17.19-.22c.51-.58,1.08-1.16,1.65-1.75a37.25,37.25,0,0,0,2.75-3.17,9.55,9.55,0,0,0,1-1.63,2.48,2.48,0,0,0,.25-.82c0-.26-.1-.4-.25-.43h-.06a1.85,1.85,0,0,0-.94.15,10.38,10.38,0,0,0-1,.43c-.61.33-1.18.67-1.7,1-1,.68-1.95,1.32-2.68,1.85l-1.71,1.24a2.82,2.82,0,0,1-.63.42,2.85,2.85,0,0,1,.54-.53c.37-.33.92-.79,1.63-1.36s1.59-1.23,2.63-1.94c.53-.36,1.09-.72,1.72-1.07a8.41,8.41,0,0,1,1-.47,2,2,0,0,1,1.25-.17h-.06a.82.82,0,0,1,.7.92,2.9,2.9,0,0,1-.28,1,9.68,9.68,0,0,1-1.06,1.73,34.3,34.3,0,0,1-2.78,3.23c-.57.59-1.14,1.17-1.65,1.74l0-.39a4,4,0,0,1,1.34,1.56,1.52,1.52,0,0,1,.06,1.09,3.8,3.8,0,0,1-.5.83c-.68,1-1.33,1.94-1.94,2.82l0-.32a3.46,3.46,0,0,1,1.3,1.7,2.31,2.31,0,0,1-.27,1.89l0-.14a8.89,8.89,0,0,1,.19,3.68,3.61,3.61,0,0,1-.31.95C151.9,281.46,151.84,281.56,151.82,281.55Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.58,247.72a4.23,4.23,0,0,1-.86.6c-.57.36-1.4.87-2.44,1.49L152.63,252l-2.16,1.25a10,10,0,0,0-2.18,1.43,4.46,4.46,0,0,0-1.1,2.25c-.22.84-.43,1.64-.63,2.42l-1.09,4.09c-.32,1.16-.59,2.1-.79,2.74a4.1,4.1,0,0,1-.35,1,3.63,3.63,0,0,1,.16-1c.13-.66.35-1.61.62-2.78s.62-2.6,1-4.12q.28-1.17.6-2.43a5,5,0,0,1,1.22-2.5,11.16,11.16,0,0,1,2.3-1.5l2.18-1.22,3.7-2c1.06-.58,1.92-1,2.52-1.34A3.92,3.92,0,0,1,159.58,247.72Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M152.67,257.42c-.26.62-.29,1.2-.07,1.29s.61-.33.87-.95.29-1.19.07-1.29S152.93,256.81,152.67,257.42Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M100.75,240.21h0a29,29,0,0,1,16.42,14.95l22.38,47.62,19.28,7.82-17,4.89L126.73,304.4Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.85,315.49l-8.12,6.26L93.21,280.07,70.05,238.23l2.68-7.78,17.91,7.46,6.41,9.48,1.43-12L99.63,237l1.87,5.07s17.58,14.63,21.38,26.22C126,278,125.05,298,127,303.4Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.71,237.69c-.27.81-17.32,7.66-18.13,13.63s12.25,52.13,12.25,52.13l20.71,18.3h53.19l-16.87-31.59A80.22,80.22,0,0,0,103.2,271.6c-5-5.06-11-11.32-14.14-15.05-3.37-4.05-17.66-23-17.66-23Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.38,239.58a21.1,21.1,0,0,1,3,1.35c1.83.9,4.34,2.16,7.1,3.59l3.14,1.64-.36.24a22.72,22.72,0,0,1,.33-5.58,7.67,7.67,0,0,1,.59-2.11,21.73,21.73,0,0,1-.28,2.16,27.34,27.34,0,0,0-.15,5.49l0,.44-.39-.2L86.26,245c-2.76-1.43-5.24-2.75-7-3.73A21.85,21.85,0,0,1,76.38,239.58Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.38,281.68a10.07,10.07,0,0,1-.85-1.35l-2.17-3.77c-1.82-3.19-4.36-7.58-7.22-12.39s-5.53-9.12-7.46-12.24l-2.29-3.7a9.65,9.65,0,0,1-.78-1.39,8.47,8.47,0,0,1,1,1.28c.59.84,1.42,2.07,2.43,3.61,2,3.07,4.72,7.36,7.6,12.18s5.35,9.24,7.09,12.47c.88,1.62,1.57,2.93,2,3.85A9.74,9.74,0,0,1,117.38,281.68Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.19,313.86c3.09.52,6.26,1,9.34.46s6.09-2.53,7.06-5.51a5.86,5.86,0,0,1,1.15-2.67c1.19-1.1,3.09-.42,4.7-.57a5.89,5.89,0,0,0,4.28-3,17.33,17.33,0,0,0,1.79-5.09,7.72,7.72,0,0,0,.32-2.65,2.66,2.66,0,0,0-1.38-2.15c-1.22-.55-2.6.25-3.68,1C124,300,116,307.34,108,314.64",
    transform: "translate(-22.74 -29.01)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M129.06,278.62s3.05-7,4.67-8,9.71-5.69,9.71-5.69l-1,3.85,7.91-5.49c1-.65,6.61-5.78,7.61-3.78.73,1.44-3.88,5.24-4.5,6.09-1.54,2.11-1,1.92-1,1.92s1.67,1,.83,2.5a33.57,33.57,0,0,1-2.26,3.32s2.2.78.92,3.64a7.68,7.68,0,0,1,.22,3.67c-.36,2.14-4.22,6.19-4.22,6.19L128.65,296l-7.76-13.16Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.25,265.46,96.59,291.8,124,279.92s11.35,6.62,9.78,13.86L109.08,314a22.06,22.06,0,0,1-16.69,4.85h0a22.08,22.08,0,0,1-15.77-9.79L58.78,281.94l-10-16.31a15.22,15.22,0,0,1,.42-16.87,12.29,12.29,0,0,1,3.52-3.31C57.19,242.74,70.43,241.56,84.25,265.46Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M144.93,267a23.07,23.07,0,0,1-4,2.77,24.27,24.27,0,0,1-4.28,2.35,25.39,25.39,0,0,1,4-2.77A25.23,25.23,0,0,1,144.93,267Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.64,266.74a27.44,27.44,0,0,1-3.59,3.88,29.62,29.62,0,0,1-3.93,3.53,28.76,28.76,0,0,1,3.59-3.88A29.48,29.48,0,0,1,152.64,266.74Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M151.61,272.68a8.63,8.63,0,0,1-1.68,2.35c-1,1.21-2,2.13-2.06,2a8.77,8.77,0,0,1,1.69-2.36A8.64,8.64,0,0,1,151.61,272.68Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152,276.68c.11.09-.32.73-.86,1.51s-1,1.4-1.13,1.33.17-.81.73-1.61S151.87,276.59,152,276.68Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.88,316.64s0-.05.12-.12l.39-.33,1.55-1.25,5.92-4.68L134,293.72l-.09.17a10.35,10.35,0,0,0-.77-4,16.8,16.8,0,0,0-2.27-3.71,29,29,0,0,0-7-6l.23,0-14.17,6.16L96.69,292l-.22.09-.11-.21c-3.63-7.15-7-13.87-10.38-19.71-1.69-2.93-3.36-5.64-4.94-8.17s-3-4.87-4.49-6.89a25.45,25.45,0,0,0-8.52-7.9c-.59-.35-1.14-.62-1.62-.85s-.87-.42-1.21-.56l-.74-.33a1.27,1.27,0,0,1-.25-.12A24.43,24.43,0,0,1,72.29,252a29,29,0,0,1,4.53,5c1.5,2,3,4.36,4.55,6.88s3.29,5.22,5,8.15c3.44,5.84,6.81,12.56,10.46,19.7l-.33-.12,13.19-5.74,14.17-6.15.12-.05.11.07a29.44,29.44,0,0,1,7.12,6.14,17.84,17.84,0,0,1,2.33,3.83,11.22,11.22,0,0,1,.79,4.24v.1l-.09.07L113,310.47l-6,4.58-1.59,1.2-.42.3Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.93,300.08c-.15-.06.61-1.94,1-4.37s.4-4.46.56-4.47a10.33,10.33,0,0,1,0,4.56A10.18,10.18,0,0,1,94.93,300.08Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M245.46,377.45l14.33,17.95s23.06-8.53,26-5.47L252,419l-23.47-27Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M248.08,402.92a1.81,1.81,0,0,0,.4,2.39,1.75,1.75,0,0,0,2.38-.37,1.93,1.93,0,0,0-.44-2.54,1.82,1.82,0,0,0-2.43.67",
    transform: "translate(-22.74 -29.01)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M252,419l-2.26-2.82L283,389.36s2.07-.64,2.81.57Z",
    transform: "translate(-22.74 -29.01)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.19,394.76c.14.17-.62,1-1,2.18s-.19,2.3-.4,2.36-.78-1.1-.32-2.58S260.1,394.58,260.19,394.76Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265,393.18c.17.13-.3,1-.26,2.21s.51,2.05.34,2.19-1.08-.71-1.1-2.18S264.86,393,265,393.18Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M270.66,395.7c-.12.16-1.06-.47-1.42-1.73s.12-2.29.3-2.22.13,1,.43,2S270.81,395.54,270.66,395.7Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.47,391c.06.21-.89.64-1.77,1.5s-1.35,1.78-1.56,1.72,0-1.26,1-2.26S256.44,390.83,256.47,391Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "225.56 352 228.12 355.2 211.37 369.31 208.95 366.54 225.56 352"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.51,387.47c.07.06-.5.72-1.7,1.44a9.92,9.92,0,0,1-2.23,1,11.82,11.82,0,0,1-1.42.32,2.85,2.85,0,0,1-.85,0,1,1,0,0,1-.83-.82,1.18,1.18,0,0,1,.4-1,2.51,2.51,0,0,1,.71-.46,7.95,7.95,0,0,1,3.8-.86,3.71,3.71,0,0,1,2.18.52c0,.12-.86-.07-2.17,0a9.44,9.44,0,0,0-2.24.45,8.22,8.22,0,0,0-1.23.54c-.44.21-.75.47-.7.71,0,.09,0,.11.2.15a2.35,2.35,0,0,0,.63,0,13.08,13.08,0,0,0,1.33-.25,12.85,12.85,0,0,0,2.17-.78A14.42,14.42,0,0,1,253.51,387.47Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.5,387.89c0,.07-.87-.24-1.85-1.26a7.18,7.18,0,0,1-1.81-3.45,1.84,1.84,0,0,1,.35-1.78,1,1,0,0,1,1.11-.13,3,3,0,0,1,.71.47,5.08,5.08,0,0,1,1.75,3.51c.1,1.44-.42,2.23-.49,2.19a16,16,0,0,0,0-2.13,5,5,0,0,0-.83-2.05,4.31,4.31,0,0,0-.87-.95c-.36-.31-.74-.49-.85-.34a1.29,1.29,0,0,0-.11,1.07,6.25,6.25,0,0,0,.37,1.27,8,8,0,0,0,1.12,2C252.86,387.32,253.57,387.78,253.5,387.89Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.89,432.79,229,456.27s23.57,8.79,23.83,13.15l-45.6-.09-.11-36.65Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M214.9,454.27a1.86,1.86,0,0,0-1.29,2.12,1.81,1.81,0,0,0,2.1,1.3,2,2,0,0,0,1.35-2.26,1.86,1.86,0,0,0-2.32-1.11",
    transform: "translate(-22.74 -29.01)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M207.23,469.33l.14-3.7L251,467.1s2,.89,1.8,2.32Z",
    transform: "translate(-22.74 -29.01)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.74,456c0,.22-1.12.32-2.22,1s-1.68,1.64-1.89,1.55.13-1.37,1.48-2.21S229.79,455.84,229.74,456Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.52,458c0,.21-.92.59-1.68,1.53s-1,1.94-1.2,1.93-.36-1.27.61-2.42S234.51,457.82,234.52,458Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.22,463.76c-.2,0-.51-1.07.07-2.29s1.61-1.7,1.71-1.51-.56.83-1,1.84S237.44,463.74,237.22,463.76Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.35,450.67c-.1.2-1.12-.11-2.38,0s-2.24.48-2.35.29.83-1,2.31-1.06S229.46,450.49,229.35,450.67Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "206.97 408.43 206.82 412.61 184.41 412.36 184.39 408.59 206.97 408.43"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.44,445.92a4.18,4.18,0,0,1-2.28,0,10.48,10.48,0,0,1-3.7-1.44,2.61,2.61,0,0,1-.69-.54,1,1,0,0,1-.1-1.18,1.25,1.25,0,0,1,1-.51,3,3,0,0,1,.85.12,8.08,8.08,0,0,1,3.53,1.88c1.05,1,1.41,1.81,1.33,1.85s-.61-.62-1.68-1.43a9.44,9.44,0,0,0-2-1.15,7.7,7.7,0,0,0-1.31-.41c-.48-.13-.89-.13-1,.08s-.05.12.05.26a2.25,2.25,0,0,0,.51.39,9.93,9.93,0,0,0,1.2.69,12.31,12.31,0,0,0,2.21.85A16.94,16.94,0,0,1,229.44,445.92Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.15,446.24a3.58,3.58,0,0,1-.6-2.2,7.54,7.54,0,0,1,.9-3.89,1.9,1.9,0,0,1,1.46-1.15,1.07,1.07,0,0,1,1,.64,3.37,3.37,0,0,1,.24.84,5.21,5.21,0,0,1-1,3.89c-.9,1.18-1.83,1.45-1.85,1.37s.71-.54,1.39-1.67a5.25,5.25,0,0,0,.73-2.15,4.9,4.9,0,0,0,0-1.32c-.07-.48-.25-.87-.43-.82s-.62.36-.81.74a7.54,7.54,0,0,0-.56,1.24,8,8,0,0,0-.45,2.28C229,445.38,229.27,446.21,229.15,446.24Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "184.03 292.74 229.15 352.7 208.05 370.83 186.32 342.42 184.03 292.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.23,324.62s72.6-22.12,79.25-21.84,19.27,24.29,19.27,24.29l-20.38-.74c-5.23,12.83-14.89,26-25.77,39.34l-41.67-1.94Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.57,307.14c0,.14-7.42,2.48-16.66,5.23s-16.77,4.86-16.81,4.72,7.41-2.48,16.66-5.22S170.53,307,170.57,307.14Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M187.44,325.94h20.38a24,24,0,0,1,22.61,16h0A37,37,0,0,1,232.49,356L230.9,439H203.47l-.5-26.5-3.47-50.37-23.75,1-13.46-.84Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.05,325.53a13.48,13.48,0,0,1-.39,1.75,43.71,43.71,0,0,1-1.44,4.68,47.16,47.16,0,0,1-3,6.6,52.76,52.76,0,0,1-5,7.39,134.12,134.12,0,0,1-11.08,11.71l-3.52,3.39a11,11,0,0,1-1.34,1.19,13.46,13.46,0,0,1,1.19-1.34c.79-.84,2-2,3.41-3.5a159.2,159.2,0,0,0,10.93-11.78,53.73,53.73,0,0,0,8.06-13.79c.72-1.92,1.27-3.5,1.59-4.6A11.15,11.15,0,0,1,188.05,325.53Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213,326.5a36.38,36.38,0,0,1-3.71-.18c-2.28-.13-5.44-.22-8.92-.15s-6.64.28-8.93.43a29.25,29.25,0,0,1-3.7.19,4,4,0,0,1,1-.21c.63-.1,1.55-.22,2.69-.35,2.28-.24,5.44-.51,9-.58a77.6,77.6,0,0,1,9,.31c1.14.1,2.06.23,2.7.33A4.11,4.11,0,0,1,213,326.5Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.35,423.8a3.86,3.86,0,0,1-.08-.69c0-.51-.06-1.16-.11-2-.08-1.79-.19-4.27-.32-7.3-.27-6.16-.64-14.67-1.23-24.06s-1.29-17.89-1.8-24c-.25-3-.45-5.5-.59-7.28-.06-.82-.1-1.48-.14-2a2.86,2.86,0,0,1,0-.7,5.33,5.33,0,0,1,.11.69l.24,2c.19,1.77.44,4.24.76,7.26.6,6.14,1.35,14.64,1.95,24s.9,17.92,1.08,24.09c.06,3,.12,5.51.16,7.3,0,.82,0,1.48,0,2A3.08,3.08,0,0,1,203.35,423.8Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.53,352.84c.15,0,.05,19-.21,42.43s-.6,42.43-.74,42.43-.05-19,.22-42.44S232.39,352.84,232.53,352.84Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.15,349.74a47.93,47.93,0,0,0-5.86,2.76,48.42,48.42,0,0,0-5.11,4,5.5,5.5,0,0,1,1.2-1.51,19,19,0,0,1,7.88-4.83A5.65,5.65,0,0,1,210.15,349.74Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.29,362.25c5.54,1,11.61-.67,16.35-3.63a22,22,0,0,0,9.6-13c.61-2.39.79-4.87,1.4-7.26a10.9,10.9,0,0,1,3.71-6.27c2.32-1.73,8-2.83,9.74-5.15,0-.34-6.78.44-9.05.57-2.48.13-6.63.76-6.54.47a61.6,61.6,0,0,1-2.4,7.07c-4.94,8.49-15.79,21-22.81,27.24",
    transform: "translate(-22.74 -29.01)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "26.42 391.93 34.14 442.4 41.79 442.4 38.02 392.12 26.42 391.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "162.21 392.12 162.21 442.4 170.29 442.4 173.3 391.93 162.21 392.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.79,265s-10.81.43-14.12,5c-5.83,8-2.55,14.92-2.88,17.28S49.16,420.94,49.16,420.94h7.7L196,422.23,202.72,406l-3.22-43.91-37.21.16s-15.24-43.74-28.56-46.66c-9-2-30.21-1.28-43-.62a17.8,17.8,0,0,1-15.87-8.11Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.15,415.78s-.77.1-2.25.17-3.66.12-6.48.14c-5.65.08-13.84.1-24,.09-20.41,0-48.86-.17-81-.45h-.21l0-.2c-.58-2.75-1.17-5.58-1.77-8.45s-1.17-5.81-1.76-8.76c-7-35.62-11.08-68.26-13.28-91.93-1.11-11.83-1.77-21.43-2.19-28.07-.18-3.3-.33-5.87-.42-7.64,0-.86-.07-1.52-.1-2s0-.68,0-.68,0,.23.07.68.08,1.13.14,2c.12,1.76.3,4.33.52,7.63.48,6.63,1.2,16.22,2.35,28.05C43,330,47.11,362.61,54.09,398.21q.88,4.43,1.76,8.75t1.77,8.45l-.25-.2,81,.63,24,.06,6.48,0c.74,0,1.29-.06,1.67-.06Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.68,422a2.47,2.47,0,0,1,.06-.63c.07-.46.15-1.05.26-1.77s.28-1.71.4-2.81.32-2.34.41-3.73.27-2.89.33-4.53.11-3.37.14-5.21a111.1,111.1,0,0,0-.7-11.92,114.69,114.69,0,0,0-2.06-11.76c-.84-3.58-1.74-6.76-2.61-9.41-.39-1.33-.84-2.5-1.2-3.55s-.69-1.94-1-2.66l-.62-1.68a2.39,2.39,0,0,1-.18-.6,3.13,3.13,0,0,1,.28.56l.71,1.64c.31.72.68,1.6,1,2.64s.86,2.21,1.28,3.54c.91,2.63,1.86,5.82,2.73,9.41a109.62,109.62,0,0,1,2.11,11.81,106.69,106.69,0,0,1,.66,12c0,1.85-.06,3.6-.19,5.24s-.24,3.16-.39,4.54-.34,2.64-.5,3.73-.32,2-.48,2.8-.27,1.3-.36,1.76A3,3,0,0,1,169.68,422Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.69,327.87a3.74,3.74,0,0,1,.56-.47c.43-.33,1-.75,1.68-1.29l1.23-.91c.46-.31,1-.61,1.55-.95a34.37,34.37,0,0,1,3.87-2.16L78.9,321c.8-.4,1.69-.69,2.58-1.06s1.82-.75,2.8-1.06l3-1A87.19,87.19,0,0,1,101.13,315a100.5,100.5,0,0,1,14.09-.86c2.17,0,4.23.14,6.16.21s3.71.3,5.34.53a71.37,71.37,0,0,1,7.64,1.41l2,.56a4.7,4.7,0,0,1,.7.23,3.78,3.78,0,0,1-.73-.13l-2.06-.47c-1.78-.37-4.39-.86-7.64-1.23-1.62-.21-3.41-.31-5.32-.47s-4-.21-6.14-.16a106.3,106.3,0,0,0-14,.89,90.37,90.37,0,0,0-13.75,2.82l-3,.93c-1,.3-1.89.7-2.79,1s-1.78.64-2.58,1-1.58.74-2.32,1.09a37.75,37.75,0,0,0-3.88,2.08c-.56.32-1.09.61-1.57.9l-1.24.88-1.73,1.2A4.28,4.28,0,0,1,67.69,327.87Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M150.41,335s0,.11-.1.33-.17.53-.34.95a13.1,13.1,0,0,1-2.05,3.27,16.86,16.86,0,0,1-4.81,3.78,24,24,0,0,1-3.54,1.47,24.42,24.42,0,0,1-4.22.86,34.6,34.6,0,0,1-9.8-.56c-3.49-.62-7.12-1.63-11-2.55a48.85,48.85,0,0,0-12.22-1.62,23.13,23.13,0,0,0-6.4,1,19.82,19.82,0,0,0-5.94,3,34.71,34.71,0,0,0-8.68,9.89c-2.29,3.63-4.1,7.38-6,10.85A54.29,54.29,0,0,1,69.05,375a23.19,23.19,0,0,1-7.69,6.07A19.55,19.55,0,0,1,53.48,383a14.73,14.73,0,0,1-6-1.12,11.86,11.86,0,0,1-2-1.07c-.52-.39-1-.73-1.28-1l-.69-.73c-.16-.17-.23-.26-.23-.26s.1.07.26.22l.73.69c.33.28.78.6,1.29,1a12.38,12.38,0,0,0,2,1,14.65,14.65,0,0,0,5.91,1,19.58,19.58,0,0,0,7.73-1.9,23,23,0,0,0,7.53-6,54.37,54.37,0,0,0,6.16-9.32c1.91-3.46,3.72-7.22,6-10.89a35.09,35.09,0,0,1,8.81-10,20.64,20.64,0,0,1,6.08-3.08,23.93,23.93,0,0,1,6.55-1,49.11,49.11,0,0,1,12.35,1.66c3.85.94,7.47,2,10.92,2.6a35.17,35.17,0,0,0,9.7.61,23.83,23.83,0,0,0,4.15-.81,23.55,23.55,0,0,0,3.51-1.41,17,17,0,0,0,4.79-3.65A14.86,14.86,0,0,0,150.41,335Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M201.27,399l-.44.11-1.29.26a16.44,16.44,0,0,0-2,.63,10.73,10.73,0,0,0-1.25.54,12.11,12.11,0,0,0-1.38.71A34.72,34.72,0,0,0,188.5,406c-2.32,2.1-4.8,4.67-7.84,7.2a28.43,28.43,0,0,1-5.14,3.49,21.41,21.41,0,0,1-3.05,1.32l-1.65.45a16.06,16.06,0,0,1-1.71.29,21.23,21.23,0,0,1-7.21-.36,30.48,30.48,0,0,1-7.18-2.67,62.78,62.78,0,0,1-13.27-9.57c-4.2-3.81-8.49-7.84-13.49-11.14a34.2,34.2,0,0,0-7.89-3.93,22.57,22.57,0,0,0-8.42-1.17,24.8,24.8,0,0,0-8,1.92,49.52,49.52,0,0,0-7.05,3.69c-4.42,2.73-8.44,5.65-12.53,7.88a51.45,51.45,0,0,1-30.62,5.76,40.63,40.63,0,0,1-6.72-1.35,3.59,3.59,0,0,1,.45.07l1.29.28c1.13.24,2.82.55,5,.8a52.08,52.08,0,0,0,18.47-1.27A51,51,0,0,0,83.86,403c4-2.23,8.06-5.15,12.49-7.91a49.85,49.85,0,0,1,7.11-3.74,25.35,25.35,0,0,1,8.16-2,22.94,22.94,0,0,1,8.61,1.19,33.86,33.86,0,0,1,8,4c5.06,3.33,9.36,7.38,13.55,11.19a62.52,62.52,0,0,0,13.15,9.52A29.72,29.72,0,0,0,162,418a20.59,20.59,0,0,0,7.05.38,15.49,15.49,0,0,0,1.68-.28l1.62-.42a22.13,22.13,0,0,0,3-1.29,27.43,27.43,0,0,0,5.09-3.42c3-2.49,5.54-5,7.88-7.12a34.27,34.27,0,0,1,6.47-4.78,11.41,11.41,0,0,1,1.41-.69,8.83,8.83,0,0,1,1.27-.53,19.52,19.52,0,0,1,2.07-.59l1.3-.21Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M62.1,289.72a4.82,4.82,0,0,1-.27,1.26,17.21,17.21,0,0,1-1.34,3.27A19.23,19.23,0,0,1,41,304.44a16.91,16.91,0,0,1-3.44-.77,5.06,5.06,0,0,1-1.2-.5,33.59,33.59,0,0,0,4.68.91,19.61,19.61,0,0,0,19.15-10A35,35,0,0,0,62.1,289.72Z",
    transform: "translate(-22.74 -29.01)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Notifications"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 156.31,
    y: 129.31,
    width: 202.94,
    height: 65.06,
    rx: 6.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375,223.38a12.88,12.88,0,0,0,1.34-.16,6.85,6.85,0,0,0,3.44-1.83,6.6,6.6,0,0,0,1.6-2.39,8.18,8.18,0,0,0,.49-3.44c0-2.55,0-5.5,0-8.81,0-6.64,0-14.75,0-24.16,0-4.71,0-9.75,0-15.09a16.08,16.08,0,0,0-.24-4,6.75,6.75,0,0,0-5.93-5c-1.41-.06-2.9,0-4.38,0L186,158.58a6.69,6.69,0,0,0-3.13.78,6.76,6.76,0,0,0-2.4,2.14,6.85,6.85,0,0,0-1.12,3c-.09,1.06,0,2.22,0,3.32v13.31q0,13.22,0,26v6.37c0,1.06,0,2.12,0,3.16a6.82,6.82,0,0,0,.78,2.9A6.74,6.74,0,0,0,184.8,223a20.31,20.31,0,0,0,3,.11H215l83.29.06,56.15.08,15.27.05,4,0,1.35,0s-.45,0-1.35,0l-4,0-15.27,0-56.15.08-83.29.06H187.84a19.5,19.5,0,0,1-3.13-.12,7.17,7.17,0,0,1-5.9-6.81c0-1.07,0-2.11,0-3.17v-45.7c0-1.13,0-2.2.05-3.38a7.17,7.17,0,0,1,3.79-5.55,7.19,7.19,0,0,1,3.37-.84l185.27.08c1.49,0,2.94,0,4.41,0a7.12,7.12,0,0,1,6.23,5.25,7.28,7.28,0,0,1,.24,2.07v2c0,5.34,0,10.38,0,15.09,0,9.41,0,17.52,0,24.16,0,3.31,0,6.26,0,8.81a8.15,8.15,0,0,1-.52,3.49,7,7,0,0,1-5.15,4.22,7.17,7.17,0,0,1-1,.11Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M367.37,171.67a.26.26,0,0,1-.18-.07.26.26,0,0,1,0-.36l5-4.79a.26.26,0,0,1,.36,0,.25.25,0,0,1,0,.35l-5,4.79A.24.24,0,0,1,367.37,171.67Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372.35,171.69a.22.22,0,0,1-.17-.07l-4.95-4.83a.24.24,0,0,1,0-.35.25.25,0,0,1,.35,0l5,4.84a.25.25,0,0,1,0,.35A.24.24,0,0,1,372.35,171.69Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M222.78,203.49l-2-2.89a10.31,10.31,0,0,1-1.89-5.95v-6.5a10.59,10.59,0,0,0-9-10.47v-3.1a1.43,1.43,0,0,0-1.43-1.43h0a1.42,1.42,0,0,0-1.42,1.43v3a10.61,10.61,0,0,0-9.36,10.53v6.73a10.34,10.34,0,0,1-2.21,6.38l-1.75,2.23Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M206.71,208.21a4.58,4.58,0,0,0,4.76-.82,4.46,4.46,0,0,0,1.2-1.84l-8.47-.06A4.59,4.59,0,0,0,206.71,208.21Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M337,180.3c0,.14-22.73.26-50.77.26s-50.77-.12-50.77-.26,22.73-.26,50.77-.26S337,180.16,337,180.3Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.88,192.59c0,.14-28.09.26-62.73.26s-62.74-.12-62.74-.26,28.08-.26,62.74-.26S360.88,192.44,360.88,192.59Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.88,200c0,.14-28.09.26-62.73.26s-62.74-.12-62.74-.26,28.08-.26,62.74-.26S360.88,199.8,360.88,200Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 187.35,
    y: 204.52,
    width: 139.43,
    height: 44.7,
    rx: 6.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.58,278.24s.31,0,.91-.1a6.64,6.64,0,0,0,2.52-.87,6.88,6.88,0,0,0,3.41-5.88V268.2c0-4.52,0-10-.05-16.43,0-3.2,0-6.63,0-10.26a10.17,10.17,0,0,0-.22-2.7,6.62,6.62,0,0,0-1.21-2.47,6.7,6.7,0,0,0-4.92-2.6l-126,.06a6.69,6.69,0,0,0-6.48,5,7.62,7.62,0,0,0-.21,2.19v2.27c0,1.51,0,3,0,4.51v22c0,.72,0,1.45,0,2.13a7.29,7.29,0,0,0,.51,2,6.75,6.75,0,0,0,6.51,4.06h16.37l56.63.05,38.19.09,10.38.05,2.7,0,.92,0s-.32,0-.92,0l-2.7,0-10.38,0-38.19.08-56.63.06H217.39a7.27,7.27,0,0,1-7-4.36,8,8,0,0,1-.54-2.14c-.06-.76,0-1.46,0-2.18V241a8,8,0,0,1,.23-2.32,7.2,7.2,0,0,1,7-5.41l126,.09a7.11,7.11,0,0,1,6.44,5.36,10.17,10.17,0,0,1,.22,2.78c0,3.63,0,7.06,0,10.26,0,6.4,0,11.91,0,16.43,0,1.12,0,2.19,0,3.19a6.9,6.9,0,0,1-.61,2.75,7.07,7.07,0,0,1-2.93,3.22,6.67,6.67,0,0,1-2.56.84A6.36,6.36,0,0,1,342.58,278.24Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M339.48,242.79a.25.25,0,0,1-.18-.08.24.24,0,0,1,0-.35l3.43-3.29a.25.25,0,0,1,.36,0,.25.25,0,0,1,0,.35l-3.44,3.29A.23.23,0,0,1,339.48,242.79Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.9,242.8a.26.26,0,0,1-.18-.07l-3.4-3.32a.25.25,0,0,1,.35-.35l3.4,3.32a.25.25,0,0,1,0,.35A.26.26,0,0,1,342.9,242.8Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.13,264.57l-1.4-2a7.15,7.15,0,0,1-1.3-4.09V254a7.28,7.28,0,0,0-6.17-7.19v-2.13a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v2.1a7.28,7.28,0,0,0-6.43,7.23v4.62a7.09,7.09,0,0,1-1.51,4.38l-1.21,1.54Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.09,267.82a3.17,3.17,0,0,0,3.27-.56,3,3,0,0,0,.82-1.27l-5.82,0A3.19,3.19,0,0,0,229.09,267.82Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.58,248.64c0,.14-15.62.26-34.89.26s-34.88-.12-34.88-.26,15.62-.26,34.88-.26S318.58,248.49,318.58,248.64Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335,257.08c0,.15-19.3.26-43.1.26s-43.11-.11-43.11-.26,19.29-.26,43.11-.26S335,256.94,335,257.08Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335,262.14c0,.14-19.3.26-43.1.26s-43.11-.12-43.11-.26,19.29-.26,43.11-.26S335,262,335,262.14Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 187.87,
    y: 256.18,
    width: 138.38,
    height: 44.36,
    rx: 6.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.05,329.56s.31,0,.9-.09a6.69,6.69,0,0,0,2.5-.87,6.89,6.89,0,0,0,2.85-3.15,7,7,0,0,0,.59-2.66v-3.16c0-4.48,0-9.95,0-16.3,0-3.18,0-6.58,0-10.18a9.63,9.63,0,0,0-.22-2.68,6.57,6.57,0,0,0-1.19-2.45,6.7,6.7,0,0,0-4.87-2.62l-125,.05a6.73,6.73,0,0,0-6.46,5,7.49,7.49,0,0,0-.23,2.17v6.72q0,8.93,0,17.56v4.29c0,.71,0,1.44,0,2.11a7.11,7.11,0,0,0,.5,2,6.73,6.73,0,0,0,6.44,4.07h16.24l56.19.05,37.89.09,10.3.05,2.68,0,.91,0s-.31,0-.91,0l-2.68,0-10.3.05-37.89.08-56.19.06H217.84a7.27,7.27,0,0,1-6.91-4.37,7.85,7.85,0,0,1-.54-2.13c0-.74,0-1.44,0-2.16,0-1.42,0-2.85,0-4.29V292.58a7.85,7.85,0,0,1,.25-2.3,7.24,7.24,0,0,1,7-5.35l125,.11a7.05,7.05,0,0,1,5.12,2.77,7.27,7.27,0,0,1,1.25,2.58,10.83,10.83,0,0,1,.22,2.76c0,3.6,0,7,0,10.18,0,6.35,0,11.82-.05,16.3,0,1.11,0,2.17,0,3.16a7,7,0,0,1-3.56,5.9,6.59,6.59,0,0,1-2.55.83A6.22,6.22,0,0,1,342.05,329.56Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M339,294.38a.25.25,0,0,1-.18-.08.24.24,0,0,1,0-.35l3.41-3.27a.26.26,0,0,1,.36,0,.25.25,0,0,1,0,.35l-3.41,3.27A.23.23,0,0,1,339,294.38Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.42,294.39a.26.26,0,0,1-.18-.07L338.87,291a.25.25,0,0,1,.35-.36l3.37,3.3a.25.25,0,0,1,0,.35A.26.26,0,0,1,342.42,294.39Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.43,316,239,314a7,7,0,0,1-1.29-4.06v-4.42a7.24,7.24,0,0,0-6.13-7.15v-2.11a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v2.08a7.23,7.23,0,0,0-6.37,7.18v4.59a7.06,7.06,0,0,1-1.5,4.35L220.6,316Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.47,319.22a3.16,3.16,0,0,0,3.25-.56,3,3,0,0,0,.81-1.26l-5.77,0A3.14,3.14,0,0,0,229.47,319.22Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.28,300.18c0,.15-15.5.26-34.62.26s-34.62-.11-34.62-.26,15.5-.26,34.62-.26S318.28,300,318.28,300.18Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.6,308.56c0,.15-19.16.26-42.78.26s-42.78-.11-42.78-.26,19.15-.26,42.78-.26S334.6,308.42,334.6,308.56Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.6,313.58c0,.14-19.16.26-42.78.26s-42.78-.12-42.78-.26,19.15-.26,42.78-.26S334.6,313.44,334.6,313.58Z",
    transform: "translate(-22.74 -29.01)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M444.46,272.73c-10.35,5.37-18.29,14.6-24,24.76s-9.39,21.33-13,32.4L404.24,387c12.05-20.5,21.72-44.59,24.33-68.21l-8-.72c5.38-.82,9.89-4.71,12.76-9.33s4.35-9.94,5.79-15.18L429.32,295A36.22,36.22,0,0,0,444.46,272.73Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M444.46,272.73c-10.35,5.37-18.29,14.6-24,24.76s-9.39,21.33-13,32.4L404.24,387c12.05-20.5,21.72-44.59,24.33-68.21l-8-.72c5.38-.82,9.89-4.71,12.76-9.33s4.35-9.94,5.79-15.18L429.32,295A36.22,36.22,0,0,0,444.46,272.73Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.46,272.73c-10.35,5.37-18.29,14.6-24,24.76s-9.39,21.33-13,32.4L404.24,387c12.05-20.5,21.72-44.59,24.33-68.21l-8-.72c5.38-.82,9.89-4.71,12.76-9.33s4.35-9.94,5.79-15.18L429.32,295A36.22,36.22,0,0,0,444.46,272.73Z",
    transform: "translate(-22.74 -29.01)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M402.46,400.39s-26.15-31.29-25.85-61.17h10.57s-11.48-7.54-10.57-11.77,1.21-20.22,1.21-20.22l9.66,2.42s-7.24-3.62-8.15-9.36S381.44,268,381.44,268s11.77,12.38,15.39,25.05,13.13,27.46,10.34,66.09S402.46,400.39,402.46,400.39Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M415.71,403.34s28.33-18.87,34.62-42.95l-8.49-2.31s10.88-3.56,11.07-7.15,3.45-16.52,3.45-16.52l-8.29-.17s6.61-1.33,8.6-5.74S462,302.08,462,302.08s-12.17,7.37-17.85,16.77-16.56,19.2-22.77,50.87S415.71,403.34,415.71,403.34Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M388.58,295.29a1.19,1.19,0,0,1,.1.32c.06.25.14.57.23,1,.2.88.48,2.13.84,3.71s.79,3.59,1.25,5.89,1,4.92,1.54,7.82c1.12,5.8,2.31,12.74,3.52,20.46s2.36,16.23,3.41,25.19,1.82,17.52,2.43,25.31,1,14.82,1.24,20.72c.14,2.95.21,5.62.28,8s.12,4.37.13,6,0,2.9,0,3.8v1a2.14,2.14,0,0,1,0,.34,1.1,1.1,0,0,1,0-.34c0-.25,0-.57,0-1,0-.91-.08-2.18-.14-3.81s-.12-3.67-.22-6-.2-5-.37-8c-.28-5.9-.75-12.92-1.35-20.7s-1.45-16.33-2.48-25.29-2.2-17.45-3.36-25.17-2.33-14.66-3.4-20.47c-.51-2.9-1-5.53-1.46-7.83s-.82-4.29-1.15-5.91-.56-2.84-.74-3.73c-.07-.4-.13-.72-.17-1A1.72,1.72,0,0,1,388.58,295.29Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M398.83,419.55S374.9,392.41,367.48,376l5.6-2.39c-4.06.67-8.23-1.08-11.38-3.73s-5.47-6.14-7.74-9.58l7.39-1.25a27.48,27.48,0,0,1-16.14-12.51c8.72,1.44,16.61,6.23,23.11,12.21a115.88,115.88,0,0,1,14,16.22,55.51,55.51,0,0,1,5.43,8.94C391.77,392.22,398.84,409.58,398.83,419.55Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M450.71,317.88a1.27,1.27,0,0,1-.11.28l-.36.79c-.35.72-.84,1.73-1.45,3-1.28,2.61-3.1,6.4-5.29,11.11-4.4,9.41-10.19,22.54-15.91,37.32s-10.26,28.4-13.34,38.32c-1.54,5-2.75,9-3.56,11.78-.4,1.36-.72,2.43-.95,3.2l-.27.83a1.33,1.33,0,0,1-.1.28,1.28,1.28,0,0,1,.05-.29c.05-.22.12-.5.21-.85.2-.78.49-1.86.85-3.23.75-2.81,1.9-6.86,3.39-11.83,3-10,7.48-23.61,13.19-38.41s11.59-27.92,16.08-37.29c2.24-4.69,4.11-8.46,5.45-11,.66-1.26,1.17-2.26,1.55-3l.41-.77C450.65,318,450.7,317.87,450.71,317.88Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M400.86,431.19a1.79,1.79,0,0,1-.12-.5c-.07-.4-.15-.87-.24-1.44-.19-1.25-.5-3.06-.94-5.28s-1.05-4.84-1.84-7.73-1.8-6-3-9.24-2.56-6.24-3.85-8.93-2.59-5.06-3.73-7-2.09-3.52-2.78-4.59l-.77-1.24a1.65,1.65,0,0,1-.24-.45s.13.12.33.39l.86,1.18c.75,1,1.76,2.57,2.94,4.5s2.5,4.31,3.85,7,2.68,5.72,3.91,9,2.2,6.41,3,9.31,1.34,5.55,1.73,7.79.65,4.06.76,5.32c.06.58.1,1.06.14,1.46A1.56,1.56,0,0,1,400.86,431.19Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 357.33,
    y: 395.79,
    width: 52.37,
    height: 10.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "362.32 406.47 367.98 442.4 399.63 442.4 404.9 406.47 362.32 406.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M429.22,435.48c0,.16-9.91.28-22.12.28s-22.13-.12-22.13-.28,9.91-.28,22.13-.28S429.22,435.33,429.22,435.48Z",
    transform: "translate(-22.74 -29.01)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M121.62,170.09l1.09-12.92a30.22,30.22,0,1,1,9.94,4.28h0Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.62,170.09l11.11-8.56.11-.09-.13-.06h0l-.07.17a31,31,0,0,0,7.2.8,30.49,30.49,0,0,0,8.51-1.32,27.08,27.08,0,0,0,4.44-1.78c.72-.39,1.48-.76,2.21-1.17l2.16-1.42a30.47,30.47,0,0,0,12-18.89A29.89,29.89,0,0,0,169,125,30.81,30.81,0,0,0,163,113a29.78,29.78,0,0,0-11.07-8.57l-1.69-.71c-.56-.25-1.16-.39-1.73-.58s-1.15-.4-1.74-.51l-1.77-.38a11.76,11.76,0,0,0-1.78-.27l-1.78-.21-1.78,0a14.93,14.93,0,0,0-1.77,0,30.9,30.9,0,0,0-13.15,3.78,29.72,29.72,0,0,0-9.74,8.53,30.71,30.71,0,0,0-5.63,22,32.63,32.63,0,0,0,2.92,9.46,29.82,29.82,0,0,0,4.89,7.07,30.21,30.21,0,0,0,5.47,4.63l0-.08c-.64,8.26-1,12.3-1,12.93.06-.63.43-4.66,1.18-12.91v-.05l0,0a30.79,30.79,0,0,1-5.41-4.63,30,30,0,0,1-4.82-7.05,32.56,32.56,0,0,1-2.86-9.38,30.45,30.45,0,0,1,5.61-21.77,29.59,29.59,0,0,1,9.64-8.42,30.56,30.56,0,0,1,13-3.72,14.58,14.58,0,0,1,1.75,0l1.76,0,1.76.21a11.77,11.77,0,0,1,1.75.27l1.75.37c.59.11,1.14.34,1.72.5s1.16.33,1.71.58l1.66.7a29.46,29.46,0,0,1,10.94,8.46,30.43,30.43,0,0,1,5.88,11.89,29.69,29.69,0,0,1,.27,12.57A30.21,30.21,0,0,1,157,156.41l-2.13,1.41c-.73.42-1.48.78-2.19,1.17a27.59,27.59,0,0,1-4.4,1.78,30,30,0,0,1-8.43,1.34,30.81,30.81,0,0,1-7.16-.75l-.06.17h0v-.16C125.62,166.93,122.14,169.68,121.62,170.09Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.16,116.68l.93,17.56a2.85,2.85,0,0,0,2.65,2.68h0a2.84,2.84,0,0,0,3-2.49l2.13-17.62a2.24,2.24,0,0,0-2.23-2.5l-4.28,0A2.22,2.22,0,0,0,135.16,116.68Z",
    transform: "translate(-22.74 -29.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M143.33,145.75a4.28,4.28,0,1,1-2.71-5.41A4.28,4.28,0,0,1,143.33,145.75Z",
    transform: "translate(-22.74 -29.01)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostfound);
export default __webpack_public_path__ + "static/media/Lostfound.1d4b720bf8f7e18ba1dc406fcd7f3578.svg";
export { ForwardRef as ReactComponent };